/**
 * DevExtreme (esm/ui/text_box/ui.text_editor.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import TextEditorMask from "./ui.text_editor.mask";
registerComponent("dxTextEditor", TextEditorMask);
export default TextEditorMask;
